/** Simulator chrome. Chart series labels come from catalogs. */
const dictionary = {
  "en": {
    "title": "Team Simulator",
    "intro": "Our Team Simulator enables you to visualize and compare the strengths, competencies, and motivations across groups or individuals.",
    "introRest": "It offers valuable insights to identify differences, uncover commonalities, and understand key dynamics, helping you make data-driven decisions to optimize performance.",
    "instruction": "Instruction",
    "mixAndMatch": "Mix and match employees and candidates into different team configurations.",
    "mixAndMatchRest": "You will instantly see how each group's strengths and performance metrics compare, and identify the most effective team setup.",
    "helpfulTips": "Helpful Tips:",
    "tipDropdowns": "Using dropdowns below you can choose individuals from teams or pools",
    "tipSearch": "Search by team, pool, or individual name is possible by typing text in the dropdown text area",
    "tipCheckbox": "Click on the checkbox next to the name to select the individual",
    "tipCompare": "If you wish to analyze two groups or compare individuals, please select at least 2 individuals and turn on Comparison Mode at the bottom",
    "tipDrag": "Once Comparison Mode is on, you can drag and drop individuals between Group A and Group B",
    "selectFromPools": "Select From Pools:",
    "selectFromPoolsLabel": "Select From Pools",
    "selectFromTeams": "Select From Teams:",
    "selectFromTeamsLabel": "Select From Teams",
    "candidateCount": "{count} candidate",
    "candidatesCount": "{count} candidates",
    "employeeCount": "{count} employee",
    "employeesCount": "{count} employees",
    "comparisonMode": "Comparison Mode",
    "selectTwoToEnable": "Select at least 2 individuals to enable",
    "selectedGroup": "Selected Group",
    "selectedGroupA": "Selected Group A",
    "selectedGroupB": "Selected Group B",
    "dragHere": "Drag and drop individuals here",
    "vs": "VS",
    "runSimulation": "Run Team Simulation",
    "scrollCharts": "Scroll left and right to view all charts",
    "clickLabels": "Click on the labels to show or hide their data on the chart",
    "groupA": "Group A",
    "groupB": "Group B",
    "groupACorresponding": "Group A corresponding metrics",
    "groupBCorresponding": "Group B corresponding metrics",
    "highlightsGroupAFocused": "{metric} Highlights (Group A Focused)",
    "highlightsGroupBFocused": "{metric} Highlights (Group B Focused)",
    "processError": "Data received but failed to process.",
    "serverError": "There is a server error getting team analysis data. Please try again later.",
    "systemError": "There is a system error getting team analysis data. Please try again later."
  },
  "de": {
    "title": "Teamsimulator",
    "intro": "Unser Teamsimulator ermöglicht es Ihnen, Verhaltensstile, Arbeitsstile und Werte & Motivationen über Gruppen oder Einzelpersonen hinweg zu visualisieren und zu vergleichen.",
    "introRest": "Die Auswertung macht Unterschiede, Gemeinsamkeiten und zentrale Dynamiken sichtbar und schafft damit die Grundlage für datenbasierte Entscheidungen und eine gezielte Optimierung der Performance.",
    "instruction": "Anleitung",
    "mixAndMatch": "Probieren Sie verschiedene Teamkonfigurationen mit Mitarbeitenden und Kandidat:innen aus. Visualisieren Sie Ihr Team der Zukunft.",
    "mixAndMatchRest": "Sie sehen auf einen Blick, wie sich die Stärken und Limitationen der verschiedenen Gruppen unterscheiden, und können die effektivste Teamzusammensetzung identifizieren.",
    "helpfulTips": "Hilfreiche Tipps:",
    "tipDropdowns": "Über die Dropdowns unten können Sie Personen aus Teams oder Pools auswählen",
    "tipSearch": "Die Suche nach Team, Pool oder Namen ist möglich, indem Sie einfach Suchbegriffe ins Dropdown-Feld eingeben",
    "tipCheckbox": "Klicken Sie auf das Kontrollkästchen neben dem Namen, um die Person auszuwählen",
    "tipCompare": "Wenn Sie zwei Gruppen analysieren oder Personen vergleichen möchten, wählen Sie mindestens 2 Personen und aktivieren Sie den Vergleichsmodus unten",
    "tipDrag": "Sobald der Vergleichsmodus aktiv ist, können Sie Personen zwischen Gruppe A und Gruppe B hin und her bewegen.",
    "selectFromPools": "Aus Pools auswählen:",
    "selectFromPoolsLabel": "Aus Pools auswählen",
    "selectFromTeams": "Aus Teams auswählen:",
    "selectFromTeamsLabel": "Aus Teams auswählen",
    "candidateCount": "{count} Kandidat:in",
    "candidatesCount": "{count} Kandidat:innen",
    "employeeCount": "{count} Mitarbeitender",
    "employeesCount": "{count} Mitarbeitende",
    "comparisonMode": "Vergleichsmodus",
    "selectTwoToEnable": "Wählen Sie mindestens 2 Personen, um den Vergleichsmodus zu aktivieren",
    "selectedGroup": "Ausgewählte Gruppe",
    "selectedGroupA": "Ausgewählte Gruppe A",
    "selectedGroupB": "Ausgewählte Gruppe B",
    "dragHere": "Personen hierher ziehen",
    "vs": "VS",
    "runSimulation": "Teamsimulation starten",
    "scrollCharts": "Nach links und rechts scrollen, um alle Diagramme zu sehen",
    "clickLabels": "Klicken Sie auf die Beschriftungen, um deren Daten im Diagramm ein- oder auszublenden",
    "groupA": "Gruppe A",
    "groupB": "Gruppe B",
    "groupACorresponding": "Entsprechende Kennzahlen Gruppe A",
    "groupBCorresponding": "Entsprechende Kennzahlen Gruppe B",
    "highlightsGroupAFocused": "{metric} Highlights (Fokus Gruppe A)",
    "highlightsGroupBFocused": "{metric} Highlights (Fokus Gruppe B)",
    "processError": "Daten empfangen, aber Verarbeitung fehlgeschlagen.",
    "serverError": "Beim Abrufen der Teamanalysedaten ist ein Serverfehler aufgetreten. Bitte versuchen Sie es später erneut.",
    "systemError": "Beim Abrufen der Teamanalysedaten ist ein Systemfehler aufgetreten. Bitte versuchen Sie es später erneut."
  },
  "fi": {
    "title": "Tiimisimulaattori",
    "intro": "Tiimisimulaattorilla voit havainnollistaa ja vertailla ryhmien tai yksilöiden vahvuuksia, osaamista ja motivaatiotekijöitä.",
    "introRest": "Se tarjoaa arvokasta tietoa erojen ja yhtäläisyyksien tunnistamiseen sekä keskeisen dynamiikan ymmärtämiseen ja auttaa sinua tekemään dataan perustuvia päätöksiä suorituskyvyn parantamiseksi.",
    "instruction": "Ohje",
    "mixAndMatch": "Kokoa työntekijöistä ja hakijoista erilaisia tiimikokoonpanoja.",
    "mixAndMatchRest": "Näet heti, miten ryhmien vahvuudet ja suoritusmittarit eroavat toisistaan, ja löydät tehokkaimman tiimikokoonpanon.",
    "helpfulTips": "Hyödyllisiä vinkkejä:",
    "tipDropdowns": "Alla olevien pudotusvalikoiden avulla voit valita henkilöitä tiimeistä tai pooleista",
    "tipSearch": "Voit hakea tiimiä, poolia tai henkilöä nimellä kirjoittamalla pudotusvalikon tekstikenttään",
    "tipCheckbox": "Valitse henkilö napsauttamalla nimen vieressä olevaa valintaruutua",
    "tipCompare": "Jos haluat analysoida kahta ryhmää tai verrata yksilöitä, valitse vähintään 2 henkilöä ja ota vertailutila käyttöön alareunassa",
    "tipDrag": "Kun vertailutila on päällä, voit vetää henkilöitä ryhmien A ja B välillä",
    "selectFromPools": "Valitse pooleista:",
    "selectFromPoolsLabel": "Valitse pooleista",
    "selectFromTeams": "Valitse tiimeistä:",
    "selectFromTeamsLabel": "Valitse Tiimeistä",
    "candidateCount": "{count} hakija",
    "candidatesCount": "{count} hakijaa",
    "employeeCount": "{count} työntekijä",
    "employeesCount": "{count} työntekijää",
    "comparisonMode": "Vertailutila",
    "selectTwoToEnable": "Ota käyttöön valitsemalla vähintään 2 henkilöä",
    "selectedGroup": "Valittu ryhmä",
    "selectedGroupA": "Valittu ryhmä A",
    "selectedGroupB": "Valittu ryhmä B",
    "dragHere": "Vedä ja pudota henkilöt tähän",
    "vs": "VS",
    "runSimulation": "Suorita tiimisimulaatio",
    "scrollCharts": "Näet kaikki kaaviot vierittämällä vasemmalle ja oikealle",
    "clickLabels": "Näytä tai piilota tietoja kaaviossa napsauttamalla selitteitä",
    "groupA": "Ryhmä A",
    "groupB": "Ryhmä B",
    "groupACorresponding": "Ryhmä A:n vastaavat mittarit",
    "groupBCorresponding": "Ryhmä B:n vastaavat mittarit",
    "highlightsGroupAFocused": "{metric} Kohokohdat (Ryhmä A keskittynyt)",
    "highlightsGroupBFocused": "{metric} Kohokohdat (Ryhmä B keskittynyt)",
    "processError": "Tietoja vastaanotettu, mutta niiden käsittely epäonnistui.",
    "serverError": "Palvelimella tapahtui virhe tiimin analyysitietoja haettaessa. Yritä myöhemmin uudelleen.",
    "systemError": "Järjestelmässä tapahtui virhe tiimin analyysitietoja haettaessa. Yritä myöhemmin uudelleen."
  }
};

export default dictionary;
